/**
 * @generated SignedSource<<2d77c62c9afa6ec91439254eec0b4c8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTransactionQueryRenderer_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_buyer" | "checkoutSetUpActions_buyer" | "usePartialAddressTracking_buyer" | "useTrackCheckoutLoadEvent_buyer">;
  readonly " $fragmentType": "CheckoutTransactionQueryRenderer_buyer";
};
export type CheckoutTransactionQueryRenderer_buyer$key = {
  readonly " $data"?: CheckoutTransactionQueryRenderer_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTransactionQueryRenderer_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTransactionQueryRenderer_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutLayout_buyer"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutSetUpActions_buyer",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutUIActionsTransactionSetup_buyer",
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "checkoutUIReducer_buyer",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasSupportedChargeCurrency",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserPreferences",
                  "kind": "LinkedField",
                  "name": "preferences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currency",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutTrackingActions_buyer",
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "getPartialVsFullAddressTrackingLabels_buyer",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CheckoutShippingAddressList_buyer"
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "partialAddressCheckoutEligibility",
                      "variableName": "partialAddressCheckoutEligibility"
                    }
                  ],
                  "concreteType": "AddressBook",
                  "kind": "LinkedField",
                  "name": "addressBook",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "personalAddressId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Address",
                      "kind": "LinkedField",
                      "name": "addressList",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AddressValidation",
                          "kind": "LinkedField",
                          "name": "validation",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ValidationResult",
                              "kind": "LinkedField",
                              "name": "buyerShipping",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "valid",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": [
                {
                  "kind": "RootArgument",
                  "name": "partialAddressCheckoutEligibility"
                }
              ]
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePartialAddressTracking_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTrackCheckoutLoadEvent_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "98b9ada3909ed37641a59187ff251967";

export default node;
